<template>
    <div class="fill-height of-y">
        <v-row
                no-gutters
                class="of-y fill-height white"
        >
            <v-col class="fill-height of-y" cols="3">
                <div class="d-flex fill-height of-y pa-0 ma-0">
                    <div class="flex-grow-1 of-y-f">
                        <multi-select-list
                                class="flex-grow-1"
                                :items="hrPins"
                                itemKey="id"
                                :showCheckBoxes="true"
                                :multiple="false"
                                headlineKey="name"
                                subLineKey="pin"
                                v-model="selectedPinId"
                                filterLabel="Filter HR Users"
                        >
                            <div slot="header" class="px-2 pt-2">

                                <v-btn
                                        small
                                        block
                                        color="primary"
                                        @click="createPinShow = !createPinShow"
                                >
                                    <v-icon left>mdi-account-plus</v-icon>
                                    Add HR User
                                </v-btn>

                            </div>
                        </multi-select-list>
                    </div>

                    <divider color="primary darken-1" :vertical="true"/>
                    <divider color="primary darken-1" :vertical="true"/>
                </div>

            </v-col>
<!--            <divider :vertical="true" color="grey"/>-->


            <v-divider :vertical="true"></v-divider>
            <v-col class="fill-height of-y" cols="9">
                <div class="pa-2">
                    <v-card class="" tile :width="400">
                        <modify-h-r-pin v-if="!!selectedPin" :edit-pin="selectedPin" @save="upsertPin($event)">
                        </modify-h-r-pin>
                    </v-card>
                </div>
            </v-col>


            <v-dialog
                    v-model="createPinShow"
                    :width="400"
                    persistent
            >
                <v-card class="of-y d-flex flex-column">

<!--                    <div class="d-flex align-center primary pl-3 pr-2 pt-1">-->
<!--                        <div class="sub&#45;&#45;text flex-grow-1">-->
<!--                            Create HR Device User-->
<!--                        </div>-->
<!--                        <v-btn-->
<!--                                icon-->
<!--                                color="white"-->
<!--                                small-->
<!--                                @click="createPinShow = false"-->
<!--                        >-->
<!--                            <v-icon small>mdi-close</v-icon>-->
<!--                        </v-btn>-->
<!--                    </div>-->
<!--                    <divider color="primary darken-1"/>-->
<!--                    <div class="flex-grow-1">-->
                        <modify-h-r-pin @close="createPinShow = false" ref="addUser" v-if="createPinShow" :edit-pin="createPinObj" @save="upsertPin($event)"/>
<!--                    </div>-->
                </v-card>
            </v-dialog>

        </v-row>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import MultiSelectList from "../../General/Multi Select List/MultiSelectList";
import ModifyUser from "./ModifyHRPin";
import {waitForEvent} from "../../../core/socket";
import Divider from "../../General/Divider";
import ManageBarcodes from "../Manage Barcodes/ManageBarcodes";
import ModifyHRPin from "@/components/Setup/HR Pins/ModifyHRPin";

export default {
    components: {ModifyHRPin, ManageBarcodes, Divider, ModifyUser, MultiSelectList},
    props: {},
    data() {
        return {
            selectedPinId: null,
            createPinShow: false,
            createPinObj: null,
        }
    },
    watch: {

        createPinShow(val) {
            if (val)
                this.createPinObj = {
                    id: null,
                    name: null,
                    pin: null,
                    disabled: false,
                }
        }
    },
    methods: {
        async upsertPin(event) {
            let {pin, ref} = event;
            ref.loading = true;
            try {
                const eventID = await this.$newReq('POST', `setup/pin`, pin)
                const addedPinID = (await waitForEvent(eventID)).hrPins.pop().id
                this.createPinShow = false
                this.selectedPinId = addedPinID;
                this.$snack.info('Changes saved')
            } catch (e) {
                console.log(e)
                this.$snack.netWorkError()
            } finally {
                ref.loading = false
            }
        }
    },
    computed: {
        ...mapGetters(['hrPins']),
        selectedPin() {
            if (!this.selectedPinId)
                return null

            return this.hrPins.filter(obj => obj.id === this.selectedPinId).pop()
        }
    },
}
</script>

<style scoped>

</style>